//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ContainerContext } from '../../../utils';
import useEnterpriseEntitlements from '../../entitlementApi/selectors/ecAppsList/useEnterpriseEntitlements';
import getAppsById from '../actions/searchEcApps';

/** @param {import('@action-types/entitlement').EnterpriseEntitlementQueryParams & import('@tanstack/react-query').UseQueryOptions} [options] */
const useManageEcAppsListDetails = (options) => {
  const { data: entitlements } = useEnterpriseEntitlements(options);
  const appIds = entitlements?.enterpriseEntitlements?.map(({ appId }) => appId);

  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;
  const enabled = Boolean(appIds?.length && token && (options?.enabled ?? true));

  /** @type {import('@action-types/ecApp').EntpEntitlemnetsAppDetailsQueryState} */
  const data = useQuery({
    queryKey: ['manage-ec-apps-list-details', appIds, token],
    queryFn: ({ signal }) =>
      getAppsById({
        appIds,
        token,
        type: 'details',
        signal,
      }),
    ...options,
    enabled,
  });

  return data;
};

export default useManageEcAppsListDetails;
